import React from 'react';

const StatsCard = ({ count, label, icon, bgColor, isLoading = false }) => {
  return (
    <div className="bg-white rounded-sm px-5 py-4 w-56 h-44 border border-gray-100 shadow-sm hover:shadow-md transition-shadow duration-200">
      <div className="flex items-center justify-between mb-4">
        <div className={`p-3 rounded-md ${bgColor}`}>
          <span className="text-2xl">{icon}</span>
        </div>
      </div>
      
      <div className="text-3xl text-left font-medium text-[#0E1628] mb-2">
        {isLoading ? (
          <div className="flex items-center">
            <span className="inline-block w-12 h-8 bg-gray-200 animate-pulse rounded"></span>
          </div>
        ) : (
          count?.toLocaleString() || '0'
        )}
      </div>
      
      <h3 className="text-sm text-left font-normal text-[#6B635D]">
        {isLoading ? (
          <span className="inline-block w-24 h-4 bg-gray-200 animate-pulse rounded"></span>
        ) : (
          label
        )}
      </h3>
    </div>
  );
};

export default StatsCard;